import { DropdownButtonContext } from '@dixa/lib-shared-habla';
import { Channel } from 'lib-shared-types-channels';
import { memo, useContext } from 'react';
import { useMount } from 'react-use';

import { useCopilotActionRunner } from 'components/copilotActions';
import { useEditorContext } from 'utils/useEditorContext';

interface EditorCopilotDropdownExpandTextProps {
  channel?: Channel;
  csid?: string;
}

/**
 * Component that represents the "expand" action in the copilot dropdown. It
 * runs on mount and paints its progress in the editor, so the dropdown is only
 * a mounting host.
 */
export const EditorCopilotDropdownExpandText = memo(
  function EditorCopilotDropdownExpandText({
    channel,
    csid,
  }: EditorCopilotDropdownExpandTextProps) {
    const dropdownContext = useContext(DropdownButtonContext);
    const { getSelectedText } = useEditorContext();
    const { run } = useCopilotActionRunner({
      context: { actions: ['expandText'] },
      text: '',
      channel,
      csid,
      // Closing the dropdown unmounts this component while the request is still
      // in flight, so it must not be cancelled.
      abortOnUnmount: false,
    });

    useMount(() => {
      if (!getSelectedText()) {
        return;
      }

      dropdownContext.closeDropdown();
      run('expandText');
    });

    return null;
  },
);
